import { UserBar } from '../../auth/user-bar';
import { SideBarBoardSection } from './side-bar-board-section';
import { SideBarStyle } from './side-bar.style';

export function SideBar() {
  return (
    <SideBarStyle.Container>
      <UserBar />
      <SideBarBoardSection />
    </SideBarStyle.Container>
  );
}
